module.exports = __webpack_public_path__ + "img/logo.3991290d.png";